<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <router-link class="decoration" to="/dgin/index">Manage GIN</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Create Invoice
      </h6>
      <div class="container-fluid">
        <div v-if="isLoading" class="card bdr-rad2 shadow p-4 text-center"><div class="spinner-border text-primary"></div></div>
        <div v-else class="card bdr-rad2 shadow p-2">
          <div class="card-body">
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <form @submit.prevent="createInvoice">
              <div class="row">
                <div class="col-md-3"><label class="custom-label">Customer</label><input v-model="invoice.customer" class="form-control form-control-sm bdr-rad" disabled></div>
                <div class="col-md-3"><label class="custom-label">GIN No.</label><input v-model="invoice.gin_num" class="form-control form-control-sm bdr-rad" disabled></div>
                <div class="col-md-3"><label class="custom-label">SO No.</label><input v-model="invoice.so_num" class="form-control form-control-sm bdr-rad" disabled></div>
                <div class="col-md-3"><label class="custom-label">Invoice Date</label><input v-model="invoice.invoice_date" type="date" class="form-control form-control-sm bdr-rad" required></div>
              </div>
              <div class="row mt-3"><div class="col-md-6"><label class="custom-label">Remarks</label><textarea v-model="invoice.remarks" class="form-control form-control-sm bdr-rad" rows="2"></textarea></div></div>
              <div class="card custom_bdr_rds mt-3"><div class="card-body custom_bdr_rds">
                <h6 class="purchitem mb-2"><b>Invoice Items</b></h6>
                <div class="table-responsive"><table class="table table-sm table-hover invoice-table"><thead class="background_color2"><tr><th>#</th><th>Product</th><th class="text_right">Price ($)</th><th class="text_right">Qty</th><th class="text_right">Discount (%)</th><th class="text_right">Line Amount ($)</th></tr></thead><tbody>
                  <tr v-for="(item, index) in items" :key="item.id || index"><td>{{ index + 1 }}</td><td>{{ item.product_name }} ({{ item.sku }})</td><td class="text_right">{{ money(item.price) }}</td><td class="text_right">{{ item.qty }}</td><td class="text_right">{{ Number(item.discount || 0).toFixed(2) }}%</td><td class="text_right">{{ money(item.line_amount) }}</td></tr>
                  <tr v-if="!items.length"><td colspan="6" class="text-center">No invoice items found.</td></tr>
                </tbody><tfoot>
                  <tr><td colspan="5" class="text_right"><b>Sub Total </b></td><td class="text_right"><b>{{ money(total) }}</b></td></tr>
                  <tr><td colspan="5" class="text_right"><b>Special Discount </b></td><td class="text_right"><b>{{ money(invoice.special_discount) }}</b></td></tr>
                  <tr><td colspan="5" class="text_right"><b>Total </b></td><td class="text_right"><b>{{ money(grandTotal) }}</b></td></tr>
                </tfoot></table></div>
              </div></div>
              <div class="d-flex justify-content-end mt-3"><button type="button" @click="$router.push('/dgin/index')" class="btn btn-sm btn-outline-primary bdr-rad mr-2">Back</button><button type="submit" class="btn btn-sm btn-primary bdr-rad">Create Invoice</button></div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>
<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() { return { token: authService.isLoggedIn(), isLoading: true, isSaving: false, errorMessage: '', invoice: { gin_id: 0, so_id: 0, customer_id: 0, customer: '', gin_num: '', so_num: '', invoice_date: new Date().toISOString().slice(0, 10), remarks: '', special_discount: 0 }, items: [] }; },
  computed: { total() { return this.items.reduce((sum, item) => sum + Number(item.line_amount || 0), 0); }, grandTotal() { return Math.max(0, this.total - Number(this.invoice.special_discount || 0)); } },
  mounted() { this.loadInvoiceData(); },
  methods: {
    money(value) { return Number(value || 0).toFixed(2); },
    async loadInvoiceData() {
      try {
        const headers = { Authorization: 'Bearer ' + this.token };
        const ginResponse = await axios.get('/dgin/view?id=' + this.$route.query.id, { headers });
        const gin = ginResponse.data.all_data || {};
        const ginDetails = ginResponse.data.details || [];
        const salesResponse = gin.so_id ? await axios.get('/dsales/view?id=' + gin.so_id, { headers }) : { data: {} };
        const salesDetails = salesResponse.data.details || [];
        const salesById = salesDetails.reduce((map, item) => { map[item.id] = item; return map; }, {});
        const sale = salesResponse.data.all_data || salesResponse.data.quatations || {};
        this.invoice = { gin_id: Number(gin.id || 0), so_id: Number(gin.so_id || 0), customer_id: Number(sale.customer_id || 0), customer: gin.issued_to || sale.customer_name || '', gin_num: gin.gin_num || '', so_num: gin.so_num || '', invoice_date: new Date().toISOString().slice(0, 10), remarks: gin.remarks || '', special_discount: Number(sale.special_discount || 0) };
        this.items = ginDetails.map((item) => { const saleItem = salesById[item.so_dtl_id] || {}; const price = Number(saleItem.price || saleItem.selling_price || 0); const discount = Number(saleItem.discount || saleItem.line_discount || 0); const qty = Number(item.gin_qty || 0); const lineAmount = price * qty * (100 - discount) / 100; return { ...item, price, discount, qty, line_amount: lineAmount }; });
      } catch (error) { this.errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Unable to load invoice data.'; }
      finally { this.isLoading = false; }
    },
    async createInvoice() {
      this.isSaving = true;
      this.errorMessage = '';
      try {
        const { data } = await axios.post('/dinvoice/create', {
          invoice: this.invoice,
          details: this.items.map((item) => ({
            gin_dtl_id: item.id,
            id_product: item.id_product,
            price: item.price,
            qty: item.qty,
            discount: item.discount,
          })),
        }, { headers: { Authorization: 'Bearer ' + this.token, 'Content-Type': 'application/json' } });
        if (data.status === 200) {
          this.$router.push('/dinvoice/view?id=' + data.id);
        }
      } catch (error) {
        this.errorMessage = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Unable to create invoice.';
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
<style scoped>
.background_color { background: #eaf6ff; min-height: calc(100vh - 60px); }.background_color2 { background: #235983; color: #fff; }.bdr-rad { border-radius: 12px; }.bdr-rad2 { border-radius: 15px; }.decoration { color: #fff !important; text-decoration: none; }.font1 { font-size: 13px !important; }.manage-boder { background: #087df5; color: #fff; padding: 10px 15px !important; margin-bottom: 10px; }.invoice-table { font-size: small; }.text_right { text-align: right; }
</style>
